import { Loader2, Check, X } from "lucide-react";
import toast from "react-hot-toast";
import { useDriverTrips } from "../../hooks/useDriverPortal";

const STATUS_COLORS = {
  planned: { color: "#2563EB", bg: "#EFF6FF" },
  in_progress: { color: "#D97706", bg: "#FFFBEB" },
  completed: { color: "#16A34A", bg: "#F0FDF4" },
  cancelled: { color: "#DC2626", bg: "#FEF2F2" },
};

function fmtDate(iso) {
  if (!iso) return "—";
  return new Date(iso).toLocaleDateString("en-IN", { day: "numeric", month: "short", year: "numeric" });
}

export default function DriverTrips() {
  const { trips, loading, respond } = useDriverTrips();

  async function handleRespond(trip, response) {
    try {
      await respond(trip.id, response);
      toast.success(response === "accepted" ? "Trip accepted" : "Trip rejected");
    } catch (err) {
      toast.error(err.message || "Failed to update trip");
    }
  }

  if (loading) {
    return (
      <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB", display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Loader2 size={18} style={{ animation: "spin 1s linear infinite", color: "#9CA3AF" }} />
      </main>
    );
  }

  return (
    <main style={{ flex: 1, overflow: "auto", background: "#F9FAFB" }}>
      <div style={{ maxWidth: 800, margin: "0 auto", padding: "28px 24px" }}>
        <div style={{ fontSize: 20, fontWeight: 700, color: "#111827", marginBottom: 2 }}>My Trips</div>
        <div style={{ fontSize: 13, color: "#6B7280", marginBottom: 20 }}>Trips assigned to you by your fleet owner</div>

        {trips.length === 0 ? (
          <div style={{ background: "#fff", border: "1px dashed #D1D5DB", borderRadius: 14, padding: "48px 24px", textAlign: "center" }}>
            <div style={{ fontSize: 15, fontWeight: 600, color: "#374151" }}>No trips assigned yet.</div>
          </div>
        ) : (
          <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
            {trips.map(trip => {
              const s = STATUS_COLORS[trip.status] || STATUS_COLORS.planned;
              return (
                <div key={trip.id} style={{ background: "#fff", border: "1px solid #E5E7EB", borderRadius: 12, padding: "16px 18px" }}>
                  <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 10 }}>
                    <div style={{ fontSize: 14.5, fontWeight: 700, color: "#111827" }}>{trip.label || "Trip"}</div>
                    <span style={{ fontSize: 10.5, fontWeight: 700, textTransform: "capitalize", color: s.color, background: s.bg, borderRadius: 99, padding: "3px 10px" }}>{trip.status.replace("_", " ")}</span>
                  </div>
                  <div style={{ fontSize: 13, color: "#374151", marginBottom: 4 }}>
                    {trip.source.label || "Origin"} → {trip.destination.label || "Destination"}
                  </div>
                  <div style={{ fontSize: 12, color: "#9CA3AF", marginBottom: 10 }}>Created {fmtDate(trip.createdAt)}</div>

                  {trip.driverResponse === "pending" ? (
                    <div style={{ display: "flex", gap: 8 }}>
                      <button onClick={() => handleRespond(trip, "accepted")} style={{ display: "flex", alignItems: "center", gap: 6, background: "#16A34A", border: "none", borderRadius: 8, padding: "0 14px", height: 34, color: "#fff", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>
                        <Check size={13} /> Accept
                      </button>
                      <button onClick={() => handleRespond(trip, "rejected")} style={{ display: "flex", alignItems: "center", gap: 6, background: "none", border: "1px solid #FECACA", borderRadius: 8, padding: "0 14px", height: 34, color: "#DC2626", fontSize: 12.5, fontWeight: 700, cursor: "pointer" }}>
                        <X size={13} /> Reject
                      </button>
                    </div>
                  ) : (
                    <span style={{ fontSize: 11.5, fontWeight: 700, textTransform: "capitalize", color: trip.driverResponse === "accepted" ? "#16A34A" : "#DC2626" }}>
                      {trip.driverResponse}
                    </span>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div>
    </main>
  );
}
